import { classNames } from '@/lib/classNames';
import styles from './ErrorLabel.scss';

type ElementProps = JSX.IntrinsicElements['span'];
// eslint-disable-next-line @typescript-eslint/ban-types
type ErrorLabel = {};
type Props = ElementProps & ErrorLabel;

/** ErrorLabel */
export const ErrorLabel: React.FC<Props> = ({ children, ...props }) => {
  const { className, ...restProps } = props;
  return (
    <span {...restProps} className={classNames(className, 'error-label')}>
      {children}
      <style jsx>{styles}</style>
    </span>
  );
};
